import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "back-top",
    style: _normalizeStyle({ bottom: _ctx.bottom + 'px', right: _ctx.right + 'px' })
  }, [
    (_ctx.visible)
      ? (_openBlock(), _createBlock(_component_BaseIcon, {
          key: 0,
          name: "back_top",
          onClick: _ctx.backTop
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 4))
}